import React, { useEffect } from 'react';

import * as browserStorage from '../../../../misc/BrowserStorageManager';
import { history } from '../../../../redux/store/configureStore';
import { HOME_VIEW } from '../../../../constants/general';

function Logout() {
   useEffect(() => {
      browserStorage.clear(false);
      history.push(`/${HOME_VIEW}`);
      document.location.reload();
   }, []);

   return <></>;
}

export default Logout;
